<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">{{i18n('Transações para Câmbio')}}</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="responsiblesLoaded == 'not_loaded'">{{i18n('Carregando transações...')}}</div>
          <div v-if="responsiblesLoaded == 'error'">{{i18n('Algo errado. Não foi possível carregar as transações.')}}</div>
          <div v-if="responsiblesLoaded == 'not_authorized'">{{i18n('Não foi possível carregar as transações. Você não foi autorizado.')}}</div>
          <div v-if="responsiblesLoaded == 'empty'">{{i18n('Nenhuma transação para câmbio neste momento.')}}</div>
          <transition name="fade">
            <v-card class="mb-3" style="border-radius: 10px;" v-if="responsiblesLoaded == 'ok'">
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 sm7 py-0 pt-1>
                  </v-flex>
                  <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>
                    <div class="font-weight-thin">{{i18n('Registros')}}: {{responsibles.length}}</div>
                  </v-flex>
                  <v-flex xs12 pa-0>
                    <v-text-field v-model="responsiblesFilter" class="search-filter" append-icon="search"></v-text-field>
                  </v-flex>
                  <account-item
                    v-for="responsible in responsibles"
                    :key="responsible.bank_transaction_ids[0]"
                    :record="responsible"
                    @exchangeCreated="exchangeCreated"
                    @canceledTransaction="reloadData"
                  />
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-layout column>
                  <v-flex xs12>
                    <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style">
                      EXIBIR MAIS
                    </v-btn>
                    <slot></slot>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import ClientExchangeAccountItem from "./ClientExchangeAccountItem"

export default {
  name: 'ClientExchange',
  components: {
    layout: LeftBarLayout,
    'account-item': ClientExchangeAccountItem
  },
  data() {
    return {
      responsibles: [],
      showMoreBtn: false,
      responsiblesLoaded: 'not_loaded',
      responsiblesFilter: ''
    }
  },
  mounted() {
    let signed_in = this.$cookies.isKey('api_token') && this.$cookies.get('api_token') !== ''
    if (!signed_in) {
      this.$router.push('/')
    }

    this.loadResponsibles()
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    reloadData(){
      this.loadResponsibles()
    },
    exchangeCreated(id, exchange_data) {
      this.responsibles.splice(this.responsibles.findIndex(el => el.bank_transaction_ids[0] === id), 1)
      if (this.responsibles.length === 0) {
        this.responsiblesLoaded = 'empty'
      }
    },
    loadResponsibles() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.responsibles = response.body.data;

          if (this.responsibles.length === 0) {
            this.responsiblesLoaded = 'empty'
          } else {
            this.responsiblesLoaded = 'ok'
          }
        } else {
          this.responsiblesLoaded = 'error'
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.responsiblesLoaded = 'not_authorized'
        } else {
          this.responsiblesLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      this.responsiblesLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.customer__transactions_for_exchange, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>



// WEBPACK FOOTER //
// src/ClientExchange.vue